import styled from '@emotion/styled';

export const Container = styled.div`
  height: 100%;
  width: 100%;
  form {
    width: 100%;
    justify-content: center;
    align-items: center;
    p {
      font-size: 14px;
      color: red;
    }
  }
`;

export const PicContainer = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  img {
    margin-right: 8px;
  }
  @media (max-width: 800px) {
    flex-direction: column;
    img {
      margin-bottom: 8px;
    }
  }
`;

export const UploadPicInput = styled.div`
  width: 300px;
  height: 154px;
  border-radius: 8px;
  justify-content: center;
  display: flex;
  align-items: center;
  border: 2px solid lightgray;
  cursor: pointer;
`;
